import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["categoryType", "accountField"]

  connect() {
    this.toggleAccountField()
  }

  toggleAccountField() {
    if (this.categoryTypeTarget.value === 'entry') {
      this.accountFieldTarget.style.display = ''
    } else {
      this.accountFieldTarget.style.display = 'none'
    }
  }
}
